import PageClient from 'clients/offer/page_client'
import Company from 'entities/company'
import Group from 'entities/group'
import Offer from 'entities/offer'
import Recruiter from 'entities/recruiter'
import { isEmpty } from 'lodash'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import 'styles/views/offers/pages/show/components/related_offer_list.scss'
import { propTypeInstantiableTo } from 'supports/custom_prop_types'

class RelatedOfferListItem extends Component {
  static propTypes = {
    company: propTypeInstantiableTo(Company).isRequired,
    group: propTypeInstantiableTo(Group).isRequired,
    offer: propTypeInstantiableTo(Offer).isRequired,
    recruiter: propTypeInstantiableTo(Recruiter),
    cid: PropTypes.number
  }

  static defaultProps = {
    recruiter: null,
    cid: null
  }

  render() {
    const { company, group, offer, recruiter, cid } = this.props
    const url = Routes.offersPagePath({
      token_company: company.token,
      token_group: group.token,
      token_offer: offer.token,
      token_recruiter: recruiter ? recruiter.token : null,
      cid
    })
    return (
      <div className="showing-other-offers-list-item">
        <a href={url}>{offer.scoutTitle}</a>
      </div>
    )
  }
}

export default class RelatedOfferList extends Component {
  static propTypes = {
    company: propTypeInstantiableTo(Company).isRequired,
    group: propTypeInstantiableTo(Group).isRequired,
    offer: propTypeInstantiableTo(Offer).isRequired,
    recruiter: propTypeInstantiableTo(Recruiter),
    cid: PropTypes.number
  }

  static defaultProps = {
    recruiter: null,
    cid: null
  }

  state = {
    company: new Company(this.props.company),
    group: new Group(this.props.group),
    offer: new Offer(this.props.offer),
    recruiter: this.props.recruiter ? new Recruiter(this.props.recruiter) : null,
    offers: [],
    error: null,
    isLoading: false
  }

  componentDidMount() {
    const { company, group, recruiter } = this.state

    this.setState({
      isLoading: true
    })

    PageClient.getOfferPages(company.token, group.token, recruiter ? recruiter.token : null)
      .then(({ offers }) => {
        this.setState({
          offers,
          error: null,
          isLoading: false
        })
      })
      .catch(error => {
        this.setState({
          error,
          isLoading: false
        })
      })
  }

  render() {
    const { cid } = this.props
    const { company, group, offer, recruiter, offers } = this.state

    if (isEmpty(offers)) {
      return null
    }

    const items = offers
      .filter(o => o.id !== offer.id)
      .map(o => {
        return (
          <RelatedOfferListItem key={o.id} company={company} group={group} offer={o} recruiter={recruiter} cid={cid} />
        )
      })

    if (isEmpty(items)) {
      return null
    }

    return (
      <div className="showing-other-offers">
        <div className="showing-other-offers-title">{I18n.t('offers.pages.related_offer_list.title')}</div>
        <div className="showing-other-offers-list">{items}</div>
      </div>
    )
  }
}
